import { Component, Input, OnInit } from '@angular/core';
import { AccountingCounts } from 'src/app/core/interfaces/status-counts/accounting-counts';

@Component({
  selector: 'app-accounting-counts',
  templateUrl: './accounting-counts.component.html',
  styleUrls: ['./accounting-counts.component.scss'],
})
export class AccountingCountsComponent implements OnInit {
  @Input() accountingCounts: AccountingCounts;

  constructor() {}

  ngOnInit(): void {}
}
